import FilterSelector from './FilterSelector'

export default FilterSelector
